import { render, staticRenderFns } from "./Scrolltop.vue?vue&type=template&id=183d8c04&scoped=true&"
import script from "./Scrolltop.vue?vue&type=script&lang=js&"
export * from "./Scrolltop.vue?vue&type=script&lang=js&"
import style0 from "./Scrolltop.vue?vue&type=style&index=0&id=183d8c04&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "183d8c04",
  null
  
)

export default component.exports